/// <reference types="@types/google.maps" />
/* global google */

export type TrackPoint = {
  id: number
  latitude: number
  longitude: number
  altitude: number | null
  horizontalAccuracy: number | null
  speed: number | null
  course: number | null
  timestamp: string
  source: number
  segmentIndex: number
  /** Pre-computed epoch ms for `timestamp`. Set once at load time to avoid
   *  repeated Date parsing during filtering & rendering. */
  epochMs: number
}

export type GoogleType = typeof google

export type MapOverlayRefs = {
  circles: google.maps.Circle[]
  markers: google.maps.Marker[]
}

export type MapRefs = {
  markers: google.maps.Marker[]
  polylines: google.maps.Polyline[]
  circles: google.maps.Circle[]
  labels: google.maps.Marker[]
  listeners: google.maps.MapsEventListener[]
}

/** TrackPointSource enum from the iOS app (DeerGo/Models/TrackPoint.swift). */
export const SOURCE_LIVE_UPDATES = 1
export const SOURCE_FALLBACK_LOCATION = 2
export const SOURCE_SLC = 3
export const SOURCE_GPS_STOP = 12
export const SOURCE_GPX_IMPORT = 100
export const SOURCE_KML_IMPORT = 101

export const SOURCE_NAMES: Record<number, string> = {
  0: 'Unknown',
  [SOURCE_LIVE_UPDATES]: 'liveUpdates',
  [SOURCE_FALLBACK_LOCATION]: 'startUpdatingLocation',
  [SOURCE_SLC]: 'slc',
  [SOURCE_GPS_STOP]: 'gpsStop',
  [SOURCE_GPX_IMPORT]: 'gpxImport',
  [SOURCE_KML_IMPORT]: 'kmlImport',
}

/** Source name → display label, matching the iOS Swift enum. */
export const SOURCE_LABELS: Record<number, string> = {
  [SOURCE_LIVE_UPDATES]: 'liveUpdates',
  [SOURCE_FALLBACK_LOCATION]: 'startUpdatingLocation',
  [SOURCE_SLC]: 'slc',
  [SOURCE_GPS_STOP]: 'gpsStop',
  [SOURCE_GPX_IMPORT]: 'gpxImport',
  [SOURCE_KML_IMPORT]: 'kmlImport',
}

/** A VisitRecord row as stored in the iOS appData.sqlite VisitRecords table. */
export type VisitRecord = {
  id: number
  arrivalDate: string
  departureDate: string | null
  latitude: number
  longitude: number
  horizontalAccuracy: number
  invalid: number
}

/** An Activity row joined with optional ActivityType and Location display data. */
export type ActivityRecord = {
  id: number
  activityTypeId: number
  source: number
  category: number
  startDate: string
  endDate: string | null
  locationId: number | null
  notes: string | null
  parentActivityId: number | null
  typeName: string | null
  typeColor: string | null
  locationName: string | null
  locationLatitude: number | null
  locationLongitude: number | null
  startEpochMs: number
  endEpochMs: number | null
}

/** UI filter state for the four checkboxes. */
export type SourceFilters = {
  [SOURCE_LIVE_UPDATES]: boolean
  [SOURCE_FALLBACK_LOCATION]: boolean
  [SOURCE_SLC]: boolean
  visits: boolean
}

export const DEFAULT_SOURCE_FILTERS: SourceFilters = {
  [SOURCE_LIVE_UPDATES]: true,
  [SOURCE_FALLBACK_LOCATION]: true,
  [SOURCE_SLC]: true,
  visits: false,
}
